const collections = {
  sections(value) {
    const map = {
      IN_THE_SUBSCRIPTION: "Всегда в подписках MiXX",
      DISCOUNTS: "Можно настроить/ Доступные к выбору",
      ANOTHER: "Другое",
    };
    return map[value];
  },
  blocks(value) {
    const map = {
      advantages: "Преимущества",
      tariffs: "Тарифы",
      offers: "Акции и спецпредложения",
      "promo-tariff": "Промотариф",
      technology: "Технологии",
      join: "Подключение нового абонента",
    };
    return map[value];
  },
};
export function enumFilter(name, value) {
  if (typeof collections[name] === "function") {
    return collections[name](value) || value;
  }
  return value;
}
